import config from "../../config"
import RequestService from "../RequestService"

const updateEquipmentItem = (id, params, successCallback, failureCallback) => {
  RequestService.patch(`${config.backendUrl}/equipment_items/${id}`, { equipment_item: params }, successCallback, failureCallback)
}

export default updateEquipmentItem;